import { cn } from "@omni/utils/styles";

import { EnergyLabelModal } from "@/components/Modals/EnergyLabelModal/energyLabelModal";
import { useEnergyLabelContext } from "@/components/Product/energyLabel/context/energyLabel.context";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useModalRouter } from "@/utils/hooks/useModalRouter";

export const LabelNested = () => {
    const { open: openModal } = useModalRouter(ModalType.EnergyLabel);

    const energyLabel = useEnergyLabelContext();

    const modal = energyLabel.eprel || !!energyLabel.label;

    const handleOnDetailClick = () => {
        if (!modal) return;

        openModal();
    };

    return (
        <>
            <img
                className={cn("tw:h-auto tw:w-14", {
                    "tw:hover:cursor-pointer": modal
                })}
                src={energyLabel.labelNested}
                alt={energyLabel.altText}
                onClick={handleOnDetailClick}
            />
            {modal && <EnergyLabelModal />}
        </>
    );
};
